import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CoreStoreEffects } from './core-store.effects';
import { reducer } from './core-store.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('core', reducer),
    EffectsModule.forFeature([CoreStoreEffects]),
  ],
  providers: [CoreStoreEffects],
})
export class CoreStoreModule {}
